import { gql } from '@apollo/client'

export const queries = gql(`
  mutation updateProductMetadata($input: JSON) {
    updateProductMetadata(input: $input) {
      _id
  name
  code
  coverImage
  status
assets(includeAllStatuses: true) {
  _id
  url
  title
  subtitle
  type
  status
}
updatedAt price summary
tags
remarks
fullDescription
relatedProducts {
  _id
  code
  name
  coverImage
  status
}
relatedPosts {
      _id
      title
      summary
      cover
    }
 metadata {
    _id
    key
    value
    unit
    description
 }
 inStock
 inventory {
  _id
  quantityOnHand
 }
 billOfMaterials {
   _id
   product {
      _id
      code
      name
      coverImage
      status
      inventory {
        _id
        quantityOnHand
      }
      hasSubComponents
   }
   quantity
   remarks
   requiredToBuild
 }
 forSale
 hasSubComponents
 computedQuantityOnHand
 requiredComputedQuantityOnHand
 harmonizedTariffCode
 minimumQuantityAllowance
  productType
    }
  }
`)
